export const environment = {
    production: true,
    API_URL: 'https://us-central1-pineapplecms.cloudfunctions.net',
    firebase: {
        projectId: 'pineapplecms',
        appId: '1:368285120670:web:dedec5865c124be2b4a38f',
        databaseURL: 'https://pineapplecms-default-rtdb.firebaseio.com',
        storageBucket: 'pineapplecms.appspot.com',
        locationId: 'us-central',
        apiKey: 'AIzaSyBH_U503P-fu5e1pIQu8WhZAAdNYQGc0b4',
        authDomain: 'pineapplecms.firebaseapp.com',
        messagingSenderId: '368285120670',
        measurementId: 'G-5Z4W7BYNYR',
        langsURL: 'gs://pineapplecms.appspot.com/projects/pineapplecms/lang-json',
        captchaKey: '6Lde_EMrAAAAANRx4Far7XuYGj2WBHgjCtO4U7SQ',
    },
};
